// extracted by mini-css-extract-plugin
export default {"restoreButton":"SurveyActions_restoreButton__jGd3k","placeHolderShimmer":"SurveyActions_placeHolderShimmer__09jNs"};